<template>
  <div id="pagination" class="light-theme simple-pagination">
    <ul>
      <li class="disabled"><span class="current prev">&nbsp;</span></li>
      <li class="active"><span class="current">1</span></li>
      <li><span>2</span></li>
      <li><span>3</span></li>
      <li><span>4</span></li>
      <li><span>5</span></li>
      <li><span>6</span></li>
      <li class="disabled"><span class="current next">&nbsp;</span></li>

    </ul>
  </div>
</template>

<script>
export default {
  name: "CustomPagination"
}
</script>

<style scoped>

</style>
